<ng-template cellTemplate let-dataItem="dataItem">
    <div *ngIf="getMarkupValueType(dataItem) === Markup_Value_Type.CURRENCY" class="currency"
         (click)="$event['ignoreClickOutside'] = true">{{dataItem | property: field | wbo_currency}}
    </div>
    <div *ngIf="getMarkupValueType(dataItem) === Markup_Value_Type.PERCENT" class="percent"
         (click)="$event['ignoreClickOutside'] = true">{{dataItem | property: field | number:'1.2-2'}}{{'wbo.common.percent' | translate}}
    </div>
    <div *ngIf="getMarkupValueType(dataItem) === Markup_Value_Type.NONE" class="unknown"
         (click)="$event['ignoreClickOutside'] = true">{{dataItem | property: field | number:'1.2-2'}}
    </div>
</ng-template>
<ng-template editTemplate let-dataItem="dataItem" let-columnIndex="columnIndex" let-column="column"
             let-formGroup="formGroup">
    <wbo-edit-grid-cell-activator [columnIndex]="columnIndex" [select]="true"
                                  [editControl]="editControl"></wbo-edit-grid-cell-activator>
    <fui-numeric-control #editControl (focussed$)="columnFocusHandler(columnIndex)" [decimals]="2" [attr.id]="elementId"
                         [formControl]="formGroup.get(column.field)"
                         [control]="formGroup.get(column.field)"
                         [notation]="getNotation(dataItem) | translate"
                         [readOnly]="cellDisabled(formGroup, dataItem)"
                         [placeholder]="getPlaceholder(dataItem)">
    </fui-numeric-control>
</ng-template>
